import { useState } from "react";
import { toast } from "sonner";
import { FilePdf, X } from "@phosphor-icons/react";
import { Survey, saveBlob } from "../lib/api";

export function SurveyReportButton({ sessionId, name }) {
  const [open, setOpen] = useState(false);
  const [client, setClient] = useState("");
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);

  const make = async () => {
    setBusy(true);
    try {
      const blob = await Survey.report(sessionId, client.trim(), notes.trim());
      saveBlob(blob, `${(name || "survey").replace(/[^a-zA-Z0-9-_]+/g, "-")}-inspection-report.pdf`);
      toast.success("Report downloaded");
      setOpen(false);
    } catch {
      toast.error("Could not build the report");
    } finally { setBusy(false); }
  };

  return (
    <div className="relative">
      <button onClick={() => setOpen(!open)} className="btn-flat" data-testid="survey-report-btn"><FilePdf weight="bold" size={18} /> Client report</button>
      {open && (
        <div className="absolute right-0 top-full mt-2 z-[1100] w-[min(92vw,340px)] border-2 border-black bg-slate-950 backdrop-blur-xl p-4 space-y-3 shadow-xl" data-testid="survey-report-panel">
          <div className="flex items-center justify-between">
            <p className="label-mono">ONE-PAGE PDF</p>
            <button onClick={() => setOpen(false)} data-testid="survey-report-close"><X size={16} weight="bold" /></button>
          </div>
          <input value={client} onChange={(e) => setClient(e.target.value)} maxLength={80} placeholder="Client name (optional)"
            className="border-2 border-black px-3 py-2 font-mono text-sm w-full" data-testid="survey-report-client-input" />
          <textarea value={notes} onChange={(e) => setNotes(e.target.value)} maxLength={140} rows={2} placeholder="Inspector notes (optional)"
            className="border-2 border-black px-3 py-2 font-mono text-sm w-full resize-none" data-testid="survey-report-notes-input" />
          <p className="text-[11px] text-neutral-500">Includes the site map, acreage, altitude summary and up to 12 photos.</p>
          <button onClick={make} disabled={busy} className="btn-flat w-full justify-center" data-testid="survey-report-download-btn">
            <FilePdf weight="bold" size={18} /> {busy ? "Building…" : "Download PDF"}
          </button>
        </div>
      )}
    </div>
  );
}
